/**
 * LocalStorage keys - single source of truth
 */

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'vasit-access-token',
  REFRESH_TOKEN: 'vasit-refresh-token',
  AUTH_STATE: 'vasit-auth-storage',
  APP_STATE: 'vasit-app-storage',
  LANGUAGE: 'vasit-language',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
